import React, { useEffect } from "react";
import { Field } from "formik";
import BaseField from "components/util/schema_form/fields/BaseField";
import l from "components/util/l"

function normalizeDateTimeBounds(minStr, maxStr) {
  const hasTime = (str) => str == null || str.includes('T');
  const normalizedMin = hasTime(minStr) ? minStr : `${minStr}T00:00`;
  const normalizedMax = hasTime(maxStr) ? maxStr : `${maxStr}T23:59`;
  return { min: normalizedMin, max: normalizedMax };
}

const TextField = ({
  name,
  label,
  value,
  values,
  required,
  disabled,
  caption,
  helpMessage,
  defaultValue,
  textType,
  minDate,
  maxDate,
  placeholder,
  enableComments,
  setFieldValue
}) => {

  useEffect(() => {
    if (value === undefined && defaultValue != null)
      setFieldValue(name, defaultValue)
  }, [defaultValue])

  let minDateFormated = null;
  let maxDateFormated = null;

  if (textType == "datetime-local") {
    const { min, max } = normalizeDateTimeBounds(minDate, maxDate);
    minDateFormated = min;
    maxDateFormated = max;
  } else {
    minDateFormated = minDate;
    maxDateFormated = maxDate;
  }

  return (
    <BaseField
      name={name}
      label={label}
      values={values}
      required={required}
      caption={caption}
      helpMessage={helpMessage}
      enableComments={enableComments}
      setFieldValue={setFieldValue}
    >
      <Field
        id={name}
        name={name}
        class={"form-control"}
        type={textType}
        autocomplete="off"
        placeholder={l(placeholder)}
        required={required}
        disabled={disabled}
        min={minDateFormated}
        max={maxDateFormated}
        style={{ paddingLeft: "1.2rem", paddingRight: "1.2rem" }}
        value={value ?? values[name]}
        onChange={(e) => setFieldValue(name, e.target.value)}
      />
    </BaseField>
  )
}

export default TextField;